import { Stack, Stepper, Text } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";

import { builder } from "@/builders";
import { EmptySlot } from "@/components/staff/shared/empty-slot";
import { useCurrentORG } from "@/components/super-admin/org-management/use-organisation";
import { ActivityDataIcon } from "@/svgs/activity-data-icon";

import dayjs from "dayjs";

export function CompletedCoursesList() {
  const { organization } = useCurrentORG();
  const { data = [] } = useQuery({
    queryKey: builder.data.admin_dashboard.$get({
      organization: organization.id,
    }),
    queryFn: () =>
      builder.$use.data.admin_dashboard({
        organization: organization.id,
      }),
    select: ({ data }) => data.recent_activities,
  });

  if (!data.length) {
    return (
      <EmptySlot
        title="No completed courses"
        description="No courses have been completed yet."
        src="book"
      />
    );
  }

  return (
    <Stepper variant="ladder" active={data.length} orientation="vertical">
      {data.map((activity, index) => (
        <Stepper.Step
          key={index}
          icon={<ActivityDataIcon width={16} height={16} />}
          completedIcon={<ActivityDataIcon width={16} height={16} />}
          description={
            <Stack
              className="border rounded-lg border-primary-border-light bg-primary-background-subtle text-primary-text-body"
              p={8}
              gap={2}
            >
              <Text className="border-b prose-base/medium text-primary-text-body border-primary-border-light">
                {activity.name}
              </Text>
              <Text className="prose-base/regular">
                {activity.activity_type}
              </Text>
              <Text className="prose-sm/regular">{activity.note}</Text>
              <time className="prose-sm/regular text-primary-text-subtle">
                on {dayjs(activity.created_at).format("DD MMM YYYY")} @{" "}
                {dayjs(activity.created_at).format("hh:mm a")}.
              </time>
            </Stack>
          }
        />
      ))}
    </Stepper>
  );
}
